import MenuItemRow from './MenuItemRow';

export default MenuItemRow;
